export enum EmailTemplateType {
  PAYROLL_SEND_REQUEST = "payroll-send-request",
  PAYROLL_REJECT = "payroll-reject",
  PAYROLL_APPROVE_ALL = "payroll-approve-all",
  OT_SEND_REQUEST = "ot-send-request",
  OT_REJECT = "ot-reject",
  OT_APPROVE_ALL = "ot-approve-all",
  LEAVE_SEND_REQUEST = "leave-send-request",
  LEAVE_REJECT = "leave-reject",
  LEAVE_APPROVE_ALL = "leave-approve-all",
  SALARY_ADVANCE_SEND_REQUEST = "salary-advance-send-request",
  SALARY_ADVANCE_REJECT = "salary-advance-reject",
  SALARY_ADVANCE_APPROVE_ALL = "salary-advance-approve-all",
  SALARY_PAYMENT_SEND_REQUEST = "salary-payment-send-request",
  SALARY_PAYMENT_REJECT = "salary-payment-reject",
  SALARY_PAYMENT_APPROVE_ALL = "salary-payment-approve-all",
  PRODUCTIVITY_SALARY_SEND_REQUEST = "productivity-salary-send-request",
  PRODUCTIVITY_SALARY_REJECT = "productivity-salary-reject",
  PRODUCTIVITY_SALARY_APPROVE_ALL = "productivity-salary-approve-all",
  SUMMARY_PRODUCTIVITY_SALARY_SEND_REQUEST = "summary-productivity-salary-send-request",
  SUMMARY_PRODUCTIVITY_SALARY_REJECT = "summary-productivity-salary-reject",
  SUMMARY_PRODUCTIVITY_SALARY_APPROVE_ALL = "summary-productivity-salary-approve-all",
  PAYROLL_13TH_SEND_REQUEST = "payroll-13th-send-request",
  PAYROLL_13TH_REJECT = "payroll-13th-reject",
  PAYROLL_13TH_APPROVE_ALL = "payroll-13th-approve-all",
  KPI_INDIVIDUAL_SEND_REQUEST = "kpi-individual-send-request",
  KPI_INDIVIDUAL_REJECT = "kpi-individual-reject",
  KPI_INDIVIDUAL_APPROVE_ALL = "kpi-individual-approve-all",
  KPI_DEPARTMENT_SEND_REQUEST = "kpi-department-send-request",
  KPI_DEPARTMENT_REJECT = "kpi-department-reject",
  KPI_DEPARTMENT_APPROVE_ALL = "kpi-department-approve-all",
  PAYSLIP = "payslip",
  PAYSLIP_PRODUCTIVITY = "payslip-productivity",
}

export const EmailTemplateTypeOptions = Object.values(EmailTemplateType).map(
  (value) => ({
    label: value,
    value,
  })
);

export interface EmailTemplate {
  id: string;
  orgId: number;
  name: string;
  type: string;
  subject: string;
  content: string;
  language?: string;
  parameters?: string[];
  status: number;
  createdAt: string;
  updatedAt: string;
}

export interface EmailTemplateListRequest {
  keyword?: string;
  language?: string;
  type?: string;
  status?: number;
  page?: number;
  limit?: number;
}

export interface EmailTemplateListResponse extends RestAPIMetaResponse {
  items: Array<EmailTemplate>;
}

export interface EmailTemplateCreateRequest {
  name: string;
  type: string;
  subject: string;
  content: string;
  language?: string;
  parameters?: string[];
}

export interface EmailTemplateUpdateRequest
  extends Partial<EmailTemplateCreateRequest> {
  id: string;
  status?: number;
}
